import axios from 'axios';
import store from '@/store/store.js';
let http = axios.create({
	//baseURL: '/',
	baseURL: window.config.baseURL + '/' + window.config.app,
	timeout: 600000,
	withCredentials: false,
	// headers: {
	// 	'Content-Type': 'application/x-www-form-urlencoded'
	// },
	headers: {
		'Content-Type': 'application/json'
	},
	// transformRequest: [function(data) {
	// 	let newData = '';
	// 	for (let k in data) {
	// 		if (Object.prototype.hasOwnProperty.call(data, k) === true) {
	// 			newData += encodeURIComponent(k) + '=' + encodeURIComponent(data[k]) + '&';
	// 		}
	// 	}
	// 	return newData;
	// }]
});
http.interceptors.request.use(
	config => {
		//console.log(config)
		// const token = 'token'
		const token = window.localStorage.getItem(store.store.state.token)
		if (token) {
			if (config.url.indexOf("import") != -1) {
				config.headers['Content-Type'] = 'multipart/form-data';
				config.transformRequest = []
			}
			if (config.url.indexOf("file") != -1) {
				config.headers['Content-Type'] = 'multipart/form-data';
				config.transformRequest = []
			}
			if (config.url.indexOf("download") != -1 && config.url.indexOf("downloadstatic") === -1 ) {
				//config.headers['Content-Type'] = 'multipart/form-data';
				config.responseType = 'blob';
				//config.transformRequest = []
			}
			config.headers.token = token;
			//console.log(config.url.indexOf("import"))

			window.postMessage({
					event: "nazhi_getcookies",
					target: 'wlnwms'
				},
				"*"
			);
			
			//======================
			if(window.config.chrome && window.config.chrome.request){
				window.config.chrome.request(config)
			}
			//======================
			
			
		}
		return config
	},
	error => {
		return Promise.error(error)
	})
http.interceptors.response.use(response => {
		return response

	},
	error => {
		return Promise.reject(error)
	})

function apiAxios(method, url, params, response, reject, system) {
	let obj = {
		method: method,
		url: url,
		data: method === 'POST' || method === 'PUT' ? params : null,
		params: method === 'GET' || method === 'DELETE' ? params : null,
	}
	if (system) {
		// obj.baseURL = baseURL + '/system'
		obj.baseURL = window.config.baseURL + '/' + window.config.app + '/system'
	} else {
		obj.baseURL = window.config.baseURL + '/' + window.config.app
	}
	//console.log(window.config)
	http(obj).then(function(res) {
		// if (res.headers['content-type'] == 'application/pdf') {
		// 	let pdfUrl = window.URL.createObjectURL(new Blob([res.data]))
		// 	console.log(pdfUrl)
		// 	let a = document.createElement('a')
		// 	a.href = pdfUrl
		// 	a.download = '123.pdf'
		// 	a.click()
		// 	response(true)
		// 	return
		// }
		let isdownload = res.config.url.indexOf('download') !== -1
		let code = isdownload ? res.status : res.data.code
		if (code != 200) {
			if (res.data.data == 'box' || res.data.data && res.data.data.type == 'box') {
				store.store.state.app.$confirm(res.data.msg.replace(/&/g, '</br>'), '提示', {
					confirmButtonText: '确定',
					type: 'warning',
					dangerouslyUseHTMLString: true
				}).then(() => {
					reject({
						type: 'box',
						data: res.data.data.data ? res.data.data.data : null
					})
				}).catch(() => {
					if (reject) {
						reject({
							type: 'default',
							data: null
						})
					}
				})
			} else {
				store.store.state.app.$message.error(res.data.msg)
				if (reject) {
					reject({
						type: 'default',
						msg: res.data.msg,
						data: null
					})
				}
			}

			return false
		}
		if (isdownload) {
			response(res);
		} else {
			response(res.data);
		}

	}).catch((err) => {
		console.log(err)
		store.store.state.app.$message.error(err)
		if (reject) {
			reject(err)
		}
		//response(err);
	})
}

export default {
	get(url, params, response, reject = null, system = null) {
		return apiAxios('GET', url, params, response, reject, system)
	},
	post(url, params, response, reject = null, system = null) {
		return apiAxios('POST', url, params, response, reject, system)
	},
	put(url, params, response, reject = null, system = null) {
		return apiAxios('PUT', url, params, response, reject, system)
	},
	delete(url, params, response, reject = null, system = null) {
		return apiAxios('DELETE', url, params, response, reject, system)
	}
}